import { Component, OnInit } from '@angular/core';
import { SwiperConfigurationsService } from 'src/app/services/swiper-configurations.service';

@Component({
  selector: 'app-intro-page2',
  templateUrl: './intro-page2.component.html',
  styleUrls: ['./intro-page2.component.scss']
})
export class IntroPage2Component implements OnInit {

  constructor(public swiperConfigService: SwiperConfigurationsService) { }

  ngOnInit() {
    
  }

}
